var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.overview)?_c('div',_vm._l((_setup.flattened),function(token,i){return _c('span',{key:i,class:['token', token.type],on:{"click":function($event){return _setup.tokenClick(token)}}},[_vm._v(_vm._s(token.value))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }